import React from 'react'

const BenefitListContext = React.createContext<{
  dark?: boolean
  roundedBottom?: boolean
  roundedTop?: boolean
}>({})

export default BenefitListContext
